import React, { Component } from 'react'; import { Link } from 'react-router-dom';
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
} from 'semantic-ui-react';
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
} from 'react-share';

class Download extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: this.props.match.params.type,
      asset_uid: this.props.match.params.uid,
      generating: false,
    };
  }

  type = () => {
    return this.state.type.charAt(0).toUpperCase() + this.state.type.slice(1);
  }

  download = () => {
    window.open(process.env.REACT_APP_API_DOMAIN+'/api/'+this.state.type+'/download/'+this.state.asset_uid);
    this.setState({ generating: true, })
    setTimeout(() => {
      this.setState({ generating: false });
    }, 15000);
  }

  text = () => {
    return "I've just created a custom " + this.state.type + " with the creation tool of Stream Maker, go check it out!";
  }

  render() {
    return (
      <Container className="download">
         <Grid columns='three'>
          <Grid.Row>
            <Grid.Column width={2}>
            </Grid.Column>
            <Grid.Column width={12}>
              <Header style={{marginTop: '1em'}} as='h2'>
               <Icon name='check'/> Your {this.type()} is ready!
              </Header>
              <p style={{fontSize: '1.3em'}}>
                We hope you are satisfied with the result.
              </p>
              <p>
                <Button size='huge' primary onClick={this.download} disabled={this.state.generating} loading={this.state.generating}><Icon name="download" />Click here to download your content.</Button>
              </p>
              <p>
                <span style={{fontSize: '1.1em'}}>Please note that after you've clicked, the download could take a few seconds to start.</span>
              </p>
            </Grid.Column>
            <Grid.Column width={2}>
              <Header align='center'>
                Share
                <FacebookShareButton quote={this.text()} url="https://strmaker.com">
                  <FacebookIcon size={48} />
                </FacebookShareButton>
                <TwitterShareButton hashtags={['stream']} title={this.text()} url="https://strmaker.com">
                  <TwitterIcon size={48} />
                </TwitterShareButton>
              </Header>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
            </Grid.Column>
            <Grid.Column>
            </Grid.Column>
            <Grid.Column>
            </Grid.Column>
          </Grid.Row>
        </Grid>


        <Divider />

        <p>
          <strong>If you need help to use these graphics, visit our <a href="https://strmaker.com/articles/" title="Go to tutorials section">tutorials section</a>.</strong>
        </p>
        <p>
          Also, feel free to use again the creation tool
        </p>

        <Grid columns={4} stackable>
          <Grid.Column>
          </Grid.Column>
          <Grid.Column>
            <Link to="/tool/overlay"> <Button size='large'>
              <Button.Content>
                Create overlays
              </Button.Content>
            </Button>
            </Link>
          </Grid.Column>
          <Grid.Column>
            <Link to="/tool/logo">
            <Button size='large'>
              <Button.Content>
                Create logos
              </Button.Content>
            </Button>
            </Link>
          </Grid.Column>
          <Grid.Column>
          </Grid.Column>
        </Grid>
        <Grid columns={4} stackable>
          <Grid.Column>
          </Grid.Column>
          <Grid.Column>
            <Link to="/tool/banner">
            <Button size='large'>
              <Button.Content>
                Create banners
              </Button.Content>
            </Button>
            </Link>
          </Grid.Column>
            <Grid.Column>
            <Link to="/tool/panel">
            <Button size='large'>
              <Button.Content>
                Create panels
              </Button.Content>
            </Button>
            </Link>
          </Grid.Column>
          <Grid.Column>
          </Grid.Column>
        </Grid>

        <Divider hidden />

        <p>For any feedback or suggestion, don't hesitate to <a target="_blank" href="https://joq0czrvlim.typeform.com/to/sESdVPUQ">send an anonymous feedback using this link</a>!</p>
      </Container>
    )
  }
}

export default Download;




// WEBPACK FOOTER //
// ./src/Download.js